
    (function ($) {

        $.fn.SankeyWrapper = function (options) {
            var $element = this;
            var h = parseInt($element.height())        ;
            var w = parseInt($element.width());
           
            var guid = Math.floor(Math.random() * 900000) + 100000;
            var vcC = new vcCommon();
            var sub = $("<div>").attr("id", "dashboard-sankey-wrapper-" + guid).height(h).css("width", "100%").html(vcC.getLoadingIcon());
            $element.html(sub);

            var visual = new vcVisual();
            visual.setShowFullscreen(false);
            visual.setShowHeaderMenu(false);

            visual.addVisualContentByName('dashboard-sankey-wrapper-', "VISUAL_SIGNAL_SANKEY", guid, getCurrentTimestamp(), h, w, "", JSON.stringify({ "LoggerId": options.Param.LoggerId, "signalID": options.Param.SignalId, "archiveParam": options.Param, OnlyFirstLevelChildren: true }), 1);
        };

    })(jQuery);